import * as React from "react";

export default class StatAttribute extends React.Component {

    multigunEnabled = vehicle.info.tags.includes("wotx_multiWeapon");

    toValuesList = (value, newValue, separator, reverse) => {
        let ATTRIBUTE_VALUE_CLASS = "tank-config_value";
        let ATTRIBUTE_VALUE_UP_CLASS = ATTRIBUTE_VALUE_CLASS + "__up",
            ATTRIBUTE_VALUE_DOWN_CLASS = ATTRIBUTE_VALUE_CLASS + "__down";

        let currentValuesList = Array.isArray(value) ? value : [value];
        let newValuesList = Array.isArray(newValue) ? newValue : [newValue];
        let attributeValuesList = [];

        currentValuesList.map((v,i) => {
            // (0.1 + 0.2 == 0.3) --> false in javascript
            // so we add 0.0001 for scaling
            let ROUND_CLASS = ATTRIBUTE_VALUE_CLASS;
            // skip attribute value comparisons for non-int value types
            if(typeof v == "string") {
                attributeValuesList.push(<span className={ROUND_CLASS} key={i}>{v}</span>);
            } else {
                let newStat = Math.round((newValuesList[i] + 0.00001) * 100) / 100;
                let value = Math.round((v + 0.00001) * 100) / 100;
                let abs_newStat = Math.abs(newStat);
                let abs_value = Math.abs(value);
                let currentStat;
                if (newStat) {
                    // compare using absolute values only
                    if ((abs_value > abs_newStat && !(reverse)) || (abs_value < abs_newStat && reverse))
                        ROUND_CLASS += " " + ATTRIBUTE_VALUE_DOWN_CLASS;
                    if ((abs_value < abs_newStat && !(reverse)) || (abs_value > abs_newStat && reverse))
                        ROUND_CLASS += " " + ATTRIBUTE_VALUE_UP_CLASS;
                    currentStat = newStat;
                } else {
                    currentStat = value;
                }
                attributeValuesList.push(<span className={ROUND_CLASS} key={i}>{currentStat}</span>);
            }
            if (i !== currentValuesList.length-1)
                attributeValuesList.push(separator);
        });
        return attributeValuesList;
    };

    render() {
        const {label, unit, value, newValue, separator, reverse, is_fake_turret, slug} = this.props;
        // isNotEmpty checks for value type, this should cover edgecase of shots_per_clip returning null values
        let isNotEmpty = false;
        if(value != null) {
            if(typeof value === "object") {
                isNotEmpty = true;
            }
            else {
                if(value.length !== 0) {
                    isNotEmpty = true;
                }
            };
        };
        if(is_fake_turret && slug == "armory" ) {
            return null
        } else {
            return (
                <div className="tank-config_item__outer">
                    {
                        isNotEmpty &&
                        <div className="tank-config_item">
                            <div className="tank-config_type">{label}</div>
                            <div>
                                <span className="tank-config_item-values">
                                    {this.toValuesList(value, newValue, separator, reverse)}
                                </span>
                                <span className="tank-config_item-unit">{unit}</span>
                            </div>
                        </div>
                    }
                </div>
            )
        }
    }
}
